import axios from 'axios';
import type { IGenericUser } from '@bb/users';

const listOrgAdmins = async (orgId: string) => {
  const {
    data: { owner, admins },
  } = await axios.get<{ admins: IGenericUser[]; owner?: IGenericUser }>(
    `/user/admins?orgId=${orgId}`,
  );

  return { owner, admins };
};

export default listOrgAdmins;
